import { FormService } from './services'
import { FormStepConstants } from './constants'

export const FormStepsActions = {
    sendFormApplicationAction,
    getFormApplicationAction
}

function sendFormApplicationAction(data) {
    return dispatch => {
        dispatch(request())
        return FormService.sendFormApplication(data).then(
            data => dispatch(success(data)),
            error => dispatch(failure(error))
        )
    }

    function request() {
        return { type: FormStepConstants.POST_SEND_FORM_REQUEST }
    }

    function success(data) {
        return { type: FormStepConstants.POST_SEND_FORM_SUCCESS, payload: data }
    }

    function failure(error) {
        return { type: FormStepConstants.POST_SEND_FORM_ERROR, error }
    }
}

function getFormApplicationAction(data) {
    return dispatch => {
        dispatch(request())
        return FormService.getFormApplication(data).then(
            data => dispatch(success(data)),
            error => dispatch(failure(error))
        )
    }

    function request() {
        return { type: FormStepConstants.GET_SEND_FORM_RQUEST }
    }

    function success(data) {
        return { type: FormStepConstants.GET_SEND_FORM_SUCCESS, payload: data }
    }

    function failure(error) {
        return { type: FormStepConstants.GET_SEND_FORM_ERROR, error }
    }
}